import React from 'react';
import Icon from '../Icon';
import {
    Container,
    MenuContent,
    UserContent,
    IconNotification,
    IconCheckContainer,
    Name,
    Country,
    Profile,
    NameContent,
    EnvironmentAlert,
    EnvironmentAlertMobile
} from './styles';

const environmentAlert = process.env.REACT_APP_ENVIRONMENT &&
    process.env.REACT_APP_ENVIRONMENT !== "texel-connexion" &&
    process.env.REACT_APP_ENVIRONMENT !== "production";

export default function HeaderMenu({ imgLogo, user, notifications, showMenu, setShowMenu, showProfile, project, projectName }) {
    return (
        <>
            {environmentAlert &&
                <EnvironmentAlertMobile>
                    SYSTEM TEST ENVIRONMENT - {process.env.REACT_APP_ENVIRONMENT}
                </EnvironmentAlertMobile>
            }
            <Container>
                {projectName ?
                    <MenuContent projectName={projectName}>
                        <Icon name="menu" className="icon-menu" onClick={() => showMenu(true)} />
                        {imgLogo && <img src={imgLogo} alt='Logo' style={{ width: '150px' }} />}
                    </MenuContent>
                    :
                    <MenuContent>
                         <Icon name="menu" className="icon-menu" onClick={() => showMenu(true)} />
                        {imgLogo && <img src={imgLogo} alt='Logo' style={{width: '28px'}}/>}
                    </MenuContent>
                }
                {environmentAlert &&
                    <EnvironmentAlert>
                        SYSTEM TEST ENVIRONMENT - {process.env.REACT_APP_ENVIRONMENT}
                    </EnvironmentAlert>
                }
                <UserContent onClick={() => showProfile(true)}>
                    <Profile>
                        {
                            project == 'br' ?
                                <Icon name='user-gray' project={project} />
                                :
                                <>
                                    <Icon name='solid-user' />
                                    {notifications > 0 ?
                                        <IconNotification>{notifications}</IconNotification> :
                                        <IconCheckContainer><Icon name='check-ok-green' /></IconCheckContainer>
                                    }
                                </>
                        }
                    </Profile>
                    <NameContent>
                        <Name>{user?.name}</Name>
                        <Country>{user?.country}</Country>
                    </NameContent>
                </UserContent>
            </Container>
        </>
    );
}